import { useTranslation } from 'react-i18next';
import './style.less';

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'bg' ? 'en' : 'bg';
    i18n.changeLanguage(newLang);
  };

  return (
    <button className="language-switcher" onClick={toggleLanguage} aria-label="Switch language">
      <span className={i18n.language === 'bg' ? 'active' : ''}>BG</span>
      <span className="separator">/</span>
      <span className={i18n.language === 'en' ? 'active' : ''}>EN</span>
    </button>
  );
};
